import { FooterI18n } from '@/locales/base.message.locales';

export const footer: FooterI18n = {
  contact: 'Contato',
  privacy_policy: 'Politica de Privacidade',
  terms: 'Termos & Condições',
  inspiring: {
    ayrton_senna: {
      quote: 'Se você quer ser bem-sucedido precisa de dedicação total, buscar seu último limite e dar o melhor de si mesmo.',
      author: 'Ayrton Senna'
    },
    c_s_lewis: {
      quote: 'Dificuldades preparam pessoas comuns para destinos extraordinários.',
      author: 'C.S Lewis'
    },
    dalai_lama: {
      quote: 'Só existem dois dias do ano em que você não pode fazer nada: um se chama ontem e outro amanhã.',
      author: 'Dalai Lama'
    },
    confucio: {
      quote: 'Não importa o quão rápido você anda, mas a força de vontade para nunca parar.',
      author: 'Confúcio'
    },
    muhammad_ali: {
      quote: 'Para ser um campeão você tem que acreditar em si mesmo quando ninguém mais acredita.',
      author: 'Muhammad Ali'
    },
    theodore_roosevelt: {
      quote: 'Faça o que puder, com o que tiver, onde estiver.',
      author: 'Theodore Roosevelt'
    },
    fernando_sabino: {
      quote: 'No fim tudo dá certo, e se não deu certo é porque ainda não chegou ao fim.',
      author: 'Fernando Sabino'
    },
    aristoteles: {
      quote: 'Há apenas uma maneira de evitar críticas: não fazer, não falar e não ser nada.',
      author: 'Aristóteles'
    },
    winston_churchill: {
      quote: 'O pessimista vê dificuldade em toda oportunidade. O otimista vê oportunidade em toda dificuldade.',
      author: 'Winston Churchill'
    },
    frida_kahlo: {
      quote: 'Ao fim do dia, podemos aguentar muito mais do que pensamos que podemos.',
      author: 'Frida Kahlo'
    },
    michelle_obama: {
      quote: 'O sucesso não tem a ver com o lugar de onde você veio, e sim com a confiança que você tem e o esforço que você está disposto a investir.',
      author: 'Michelle Obama'
    },
    michael_jordan: {
      quote: 'Eu posso aceitar a falha, todos falham em alguma coisa. Mas eu não posso aceitar não tentar.',
      author: 'Michael Jordan'
    },
    albert_einstein: {
      quote: 'Esforce-se para não ser um sucesso, mas sim para ser valioso.',
      author: 'Albert Einstein'
    },
    stephen_hawking: {
      quote: 'Inteligência é a capacidade de se adaptar às mudanças.',
      author: 'Stephen Hawking'
    },
    bill_gates_one: {
      quote: 'A paciência é um elemento fundamental do sucesso.',
      author: 'Bill Gates'
    },
    napoleao_bonaparte: {
      quote: 'A arte de ser ora audacioso, ora prudente, é a arte de vencer.',
      author: 'Napoleao Bonaparte'
    },
    henry_ford_one: {
      quote: 'Nossos fracassos, às vezes, são mais frutíferos do que os êxitos.',
      author: 'Henry Ford'
    },
    santo_agostinho: {
      quote: 'Mesmo que já tenhas feito uma longa caminhada, há sempre um novo caminho a fazer.',
      author: 'Santo Agostinho'
    },
    oscar_wilde: {
      quote: 'Experiência é o nome que cada um dá a seus erros.',
      author: 'Oscar Wilde'
    },
    john_f_kennedy: {
      quote: 'Somente os que ousam errar muito podem realizar muito.',
      author: 'J ohn F Kennedy'
    },
    bill_gates_two: {
      quote: 'Toda empresa precisa ter gente que erra, que não tem medo de errar e que aprende com erro.',
      author: 'Bill Gates Two'
    },
    henry_ford_two: {
      quote: 'Pessoas não fracassam. Simplesmente desistem.',
      author: 'Henry Ford'
    },
    walt_disney: {
      quote: 'Se você pode sonhar, você pode realizar.',
      author: 'Walt Disney'
    },
    martin_luther_king: {
      quote: 'A hora é sempre certa para fazer a coisa certa.',
      author: 'Martin Luther King'
    },
  }
};
